import { Spacing } from '@persona-id/design-tokens';
import { ChangeEvent, useMemo } from 'react';
import styled from 'styled-components';

import CodeEditor from 'dashboard/components-lib/CodeEditor';
import { generateJsonSchemaCompletionSource } from 'dashboard/components-lib/CodeEditor/completionSources/javascript/jsonSchemaCompletionSource';
import { CaseQuery } from 'dashboard/models/case-query';
import { ModuleTable } from 'dashboard/modules/Table';
import Input from 'design-system/components/Input';
import Spacer from 'design-system/components/Spacer';
import { Heading, Label } from 'design-system/components/Text';
import { JsonSchemaObject } from 'lib/json-schema';

const Container = styled('div')`
  padding: ${Spacing[5]};
`;

const EditorContainer = styled.div`
  height: 300px;
`;

export interface TablePanelProps {
  module: ModuleTable;
  dataSchema: JsonSchemaObject;
  caseQueries: CaseQuery[];
  updateModule: (module: ModuleTable) => void;
}

const TablePanel = ({ module, dataSchema, caseQueries, updateModule }: TablePanelProps) => {
  const caseQueryNames = useMemo(() => {
    return caseQueries.map((caseQuery) => caseQuery.attributes.name);
  }, [caseQueries]);

  const updateTitle = (e: ChangeEvent<HTMLInputElement>) => {
    updateModule({ ...module, title: e.target.value } as ModuleTable);
  };

  const updateData = (data: string) => {
    // temporary solution to find case query dependencies
    const caseQueryDependencies = caseQueryNames.filter((name) =>
      data.split(/[^A-Za-z0-9]/).includes(name),
    );

    updateModule({
      ...module,
      data,
      'case-query-dependencies': caseQueryDependencies,
    } as ModuleTable);
  };

  return (
    <Container>
      <Heading size='sm'>Setting</Heading>
      <Label size='md' weight='bold'>
        Title
      </Label>
      <Input
        id='table-panel__input--title'
        type='text'
        value={module.title}
        onChange={updateTitle}
      />
      <Spacer height={3} />
      <Label size='md' weight='bold'>
        Data
      </Label>
      <EditorContainer>
        <CodeEditor
          language='jsonjs'
          completionSources={{
            javascript: [generateJsonSchemaCompletionSource(dataSchema)],
          }}
          code={module.data}
          onChange={updateData}
        />
      </EditorContainer>
    </Container>
  );
};

export default TablePanel;
